import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { startPresence, sendPresence, clearPresenceStage } from "../services/presence";

// Heartbeat "where is this visitor now" for the admin "Ao Vivo" tab
export const PresenceTracker = () => {
  const location = useLocation();
  useEffect(() => { startPresence(); }, []);
  useEffect(() => {
    if (!location.pathname.startsWith("/checkout") && !location.pathname.startsWith("/payment")) clearPresenceStage();
    sendPresence();
  }, [location.pathname]);
  return null;
};

export default PresenceTracker;
